import { Container, SectionLegal } from '@/atoms';

import type { FunctionComponent } from 'react';
import type { TypeFlexibleLegalProps } from './types';

/**
 * FlexibleLegal
 */
export const FlexibleLegal: FunctionComponent<TypeFlexibleLegalProps> = ({
  backgroundColorBottom,
  backgroundColorBottomMobile,
  backgroundColorTop,
  backgroundColorTopMobile,
  content,
  cutLevel,
  cutLevelMobile,
  textColor,
  index,
}: TypeFlexibleLegalProps) => (
  <Container
    index={index}
    backgroundColorBottom={backgroundColorBottom}
    backgroundColorTopMobile={backgroundColorTopMobile}
    backgroundColorTop={backgroundColorTop}
    backgroundColorBottomMobile={backgroundColorBottomMobile}
    cutLevel={cutLevel === null ? 50 : cutLevel}
    cutLevelMobile={cutLevelMobile === null ? 50 : cutLevel}
  >
    <SectionLegal variant={textColor} content={content} />
  </Container>
);

FlexibleLegal.displayName = 'FlexibleLegal';
